import { render, staticRenderFns } from "./DownloadMedicalCertificateButton.vue?vue&type=template&id=019d1a5e&"
import script from "./DownloadMedicalCertificateButton.vue?vue&type=script&lang=js&"
export * from "./DownloadMedicalCertificateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports